/**
 * Query params for /invoices (list, show, create) — matches backend relation indexes.
 */
export const INVOICE_RELATIONS = [
  'author',
  'order.lead',
  'currency',
  'account',
  'paymentType',
  'account.paymentType',
  'order.orderServices.service',
  'brand',
];

export const buildInvoiceRelationParams = () =>
  INVOICE_RELATIONS.reduce((acc, rel, i) => {
    acc[`relations[${i}]`] = rel;
    return acc;
  }, {});
